import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Header = styled.div`
  height: 72px;
  width: 100%;

  padding: 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const Icon = styled.img`
  margin-right: 12px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  color: ${(props) => props.theme.colors.greys.darkest};
  font: ${(props) => props.theme.fonts.h1Inter};
`;

export const CloseButton = styled.img`
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100% - 145px);

  position: relative;
`;

export const Footer = styled.div`
  height: 88px;
  width: 100%;

  padding: 24px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  bottom: 0;
  position: absolute;

  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 40%);
  border-radius: 0 0 8px 8px;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;
